export function Header() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold text-gray-900">VisionaryGraphics</h1>
        <p className="mt-1 text-gray-600">
          Quote → Prompt → Art pipeline for Wear Visionary
        </p>
      </div>
    </header>
  );
}
